import React from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from '../../SolvPatternLibrary/Button';
import { fontFamily, fontSize } from '../../../constants/text';
import { EN, SupportedLocale } from '../../../core/util/localizedStr';
import DateTime from '../../DateTime';
import { isEmptyArray } from '../../../core/util/array';

const StyledButton = styled(Button).withConfig({ componentId: 'sc-2p6kmx-0' })<{
  $borderRadius?: string;
  $marginBottom: string;
  $marginTop: string;
}>`
  width: 85%;
  height: 52px;
  box-shadow: none;
  padding: 0 18px;
  font-size: ${fontSize.default};
  font-weight: ${fontFamily.bold};
  margin-bottom: ${(props) => props.$marginBottom};
  margin-top: ${(props) => props.$marginTop};
  ${(props) => (props.$borderRadius ? `border-radius: ${props.$borderRadius};` : '')}
`;

const BookButtonAppointment = styled.div.withConfig({ componentId: 'sc-2p6kmx-1' })`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.default};
`;

type Props = {
  buttonType?: 'button' | 'submit' | 'reset';
  defaultButtonCopy?: string;
  disabled?: boolean;
  location: any;
  onModalSubmit?: () => void;
  selectedSlot: any[];
  shouldShowApptDateInButton?: boolean;
  locale?: SupportedLocale;
  marginBottom?: string;
  marginTop?: string;
  borderRadius?: string;
  'data-testid'?: string;
};

const SelectTimeButton = (props: Props) => {
  const {
    buttonType = 'submit',
    disabled,
    location,
    onModalSubmit,
    selectedSlot,
    shouldShowApptDateInButton = false,
    locale = EN,
    marginBottom = '50px',
    marginTop = '0px',
    borderRadius,
    'data-testid': dataTestId,
  } = props;

  const { t } = useTranslation();

  const { defaultButtonCopy = t('continue.capitalize') } = props;

  const getAppointmentTimeBtnText = () => {
    if (isEmptyArray(selectedSlot)) return t('select');

    const slotDate = moment.tz(selectedSlot[0].appointmentDate, location.timeZone);

    return DateTime.format(slotDate, location.timeZone, { locale })(
      t('dtFormat.selectMonthDayAtTime')
    );
  };

  return (
    <StyledButton
      $borderRadius={borderRadius}
      $marginBottom={marginBottom}
      $marginTop={marginTop}
      animationEnabled
      data-testid={dataTestId}
      disabled={disabled || isEmptyArray(selectedSlot)}
      onClick={onModalSubmit}
      status="initial"
      type={buttonType}
      variation="pinkPrimary"
    >
      {shouldShowApptDateInButton ? (
        <BookButtonAppointment>{getAppointmentTimeBtnText()}</BookButtonAppointment>
      ) : (
        <span>{defaultButtonCopy}</span>
      )}
    </StyledButton>
  );
};

export default SelectTimeButton;
